<script>
import Vue from "vue";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import moment from "moment";
import Loader from "@/components/widgets/loader";
import KanitGiris from "./StrKontrolGirisKanit/AddEdit.vue";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import DetayGiris from "./StrPerfTablolarDetayParametreGiris/Index.vue";

import BirimSecimi from "../FormComponet/BirimSecimiAnaBirim.vue";
import GostergeGirisiTablo from "./StrGostergeGirisiTablo.vue";
import yukleniyor from "../FormComponet/loader.vue";
import store from "@/state/store"; 


export default {
  mixins: [Api, Sabit],
  page: {
    title: "Gösterge Girişi",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    BirimSecimi,
    GostergeGirisiTablo,
    KanitGiris,
    DetayGiris,
    yukleniyor
  },
  data() {
    return {
      title: "Gösterge Girişi",
      items: [
        {
          text: "Anasayfa",
          href: "/",
        },
        {
          text: "Kurumsal Performans",
          active: true,
        },
        {
          text: "Gösterge Girişi",
          active: true,
        },
      ],
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      Message: {
        position: "",
        icon: "",
        title: "",
        showConfirmButton: false,
        timer: 1500,
      },
      loading:1,
      counter: 0,
      UstDonemId: null,
      secilen_birim: "",
      secilen_donem: "",
      universite_id:"",
      universite:0,
      ComboboxDonemler: [],
      ComboboxTablolar: [],
      ComboboxGDonemler: [],
      ComboboxBirimler: [],
      YuklenenTablolar: [],
      TabloDetaylar: [],
      Isbirlikciler: [],
      TabloDetay:{},
      Uygulamaid: null,
      Userid:null,
      Kullanici:null,
      Secilen: null,
      sorgula:0,
      Raporgirisid: "",
      DetayId:"",
      TabloDetayAciklama:"",
      DonemId:"",
      Hesaplanmasin:"",
      AltDonemlerDetay:[],
      BirimId:"",
      Filter: {
        DonemId: "",
        GdonemId: "",
        TabloId: "",
        BirimId: null,
      },
      OnayDurumu: null
    };
  },

  methods: {
    /* ANCHOR Combobox yükleme metodları */
    gdonem_combo_yukle(ust_id) {
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };

      this.Filter.GdonemId="";
      this.Filter.TabloId="";
      this.YuklenenTablolar = [];
      

      this.ComboboxGDonemler = [];

      let Filter = "&UstId=" + ust_id;
      this.ActionsFilterGet({Service:"StrPerfDonem", Page:Page, Filter:Filter}).then((res) => {
        this.ComboboxGDonemler = res.Data;
      });

      let tipadi = "&Birimtipadi=Üniversite";
      this.ActionsFilterGet({Service:"OBirimTip", Page:Page, Filter:tipadi}).then((res) => {
       let tipid = res.Data[0].Id;
      
              let tip = "&BirimTipId="+tipid;
              this.ActionsFilterGet({Service:"OBirim", Page:Page, Filter:tip}).then((res2) => {
                this.universite_id = res2.Data[0].Id;
              });

      });

      this.ComboboxTablolar = [];
      let tum_tablolar=[];
      Filter = "&DonemId=" + ust_id+"&Asc=SiraNo";
      this.ActionsFilterGet({Service:"StrPerfTablo", Page:Page, Filter:Filter}).then((res) => {
        tum_tablolar = res.Data;

        if (this.secilen_birim != "" && this.secilen_birim != null) {
          let Page = {
            PageNumber: "1",
            PageSize: "9999",
          };

          let Filter = "&BirimId=" + this.secilen_birim+"&DonemId=" + this.UstDonemId;


          this.ActionsFilterGet({Service: "StrBirimGosterge",  Page:Page,Filter:Filter}).then((res) => {
            this.Isbirlikciler = res.Data;
            let tablo = [];
            if (this.Isbirlikciler.length > 0) {

                for (var s = 0; s < tum_tablolar.length; s++) {

                       for (var i = 0; i < this.Isbirlikciler.length; i++) {

                        if (this.Isbirlikciler[i].Gostergeids.length>0 && this.Isbirlikciler[i].Tabloid == tum_tablolar[s].Id) {
                          tablo.push(tum_tablolar[s]);
                        }


                    }

                }
                this.ComboboxTablolar = tablo;

                if (this.ComboboxTablolar.length > 0) {
     
                      this.YuklenenTablolar = this.ComboboxTablolar;


                } else {
                      this.Message.position = "center";
                      this.Message.icon = "warning";
                      this.Message.title = this.$t('StrGostergeGirisi.Filtreleme.mesaj');
                      this.Message.showConfirmButton = false;
                      this.Message.timer = 1000;

                      Vue.swal(this.Message);
                }



            } else {
              this.ComboboxTablolar = [];
            }

          });  




        }

      });
    },

    Secilmis_Idler(secilmis) {
      if (secilmis != null) {
       
          this.tablo_combo_yukle(secilmis);
          this.secilen_birim = secilmis;

          if(this.secilen_birim==this.universite_id){
            this.universite=1;
          } else{ this.universite=0;}
      }
    },

    tablo_combo_yukle(birim_id) {
        if (this.Filter.DonemId != null && this.Filter.DonemId != "") {
           this.UstDonemId = this.Filter.DonemId;
            this.secilen_birim = birim_id;
            this.secilen_donem = this.UstDonemId;

            this.gdonem_combo_yukle(this.UstDonemId);
        } else {
            this.makeToast();
        }
    },

    /* ANCHOR yükleme butonu kodu */
    yukle() {

      if(this.secilen_birim!=null && this.secilen_birim!=""){



          this.loading=0;
          this.sorgula+=1;
          this.gdonem_combo_yukle(this.UstDonemId);
      }

    },

    kaydet(veri){

    let FormData=veri;
    if (veri.Id=="00000000-0000-0000-0000-000000000000" || veri.id==""){
      veri.Deger=0;
      veri.Onay=0;
      FormData.Deger=0;
      let data={"Deger":FormData.Deger,"DonemId":FormData.DonemId,"BirimId":FormData.BirimId,
      "DetayId":FormData.DetayId,"VeriTipi":FormData.VeriTipi,"Aciklama":FormData.Aciklama,"Onay":0,"Deleted":false}

        this.Post("StrPerfRaporGiris", data).then((res) => {
          FormData.Id=res.Data;
          this.$bvModal.hide("Aciklama");

        });

    } else {

       this.Update("StrPerfRaporGiris", FormData);
       this.$bvModal.hide("Aciklama");

    }
    },

    Get() {
  
    },

    ChangePage(DefaultPage) {
      if (DefaultPage) {
        this.Page.PageNumber = DefaultPage;
        this.Get();
      }
    },

    rightDrawer() {
      this.FilitrelemePenceresi = !this.FilitrelemePenceresi;
    },



  },

  created() {
    this.Get();

    let Page = {
      PageNumber: "1",
      PageSize: "9999",
    };

     let Filter = "&Kisaadi=STR";

    this.ActionsFilterGet({Service: "Ouygulama",  Page:Page,Filter:Filter}).then((res) => {
        if(res){
          this.Uygulamaid=res.Data[0].Id;

        }
    });

     this.Userid = store.getters.["auth/TokenUserId"] 



     let sorgu = "&Tip=1561";
          let Tip=[];
            
            this.ActionsFilterGet({Service:"OKeyValues", Page:Page, Filter:sorgu}).then((res) => {
              console.log(res)
                for(var i=0; i<res.Data.length; i++)
                {   
                    if(res.Data[i].Kod==1 || res.Data[i].Kod==2 ) { 

                        Tip.push(res.Data[i].Id);       

                    } 
                   
                }

                let altsorgu="&UstIdDoluMu=false&Approval=true";

                let tipler="";

                for (var s=0; s<Tip.length; s++){

                    tipler=tipler+"&TipId="+Tip[s];

                }

                altsorgu=altsorgu+tipler;

             

                this.ActionsFilterGet({ Service: "StrPerfDonem", Page: Page, Filter: altsorgu }).then((res) => {
                for (var i = 0; i < res.Data.length; i++) {
            
                  this.ComboboxDonemler.push(res.Data[i]);
                  
                }
              });
         
            });




  },

  filters: {
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("YYYY-MM-DD");
      }
    },
    formatDateTable(value) {
      if (value) {
        return moment(String(value)).format("DD.MM.YYYY");
      }
    },
  },
};
</script>

<template>
  <Loader>
 
    <Layout>
      <PageHeader :title="title" :items="items" />

     
      <!-- ANCHOR Filtreleme form alanı -->

      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
              
                  <div class="row">
                  <div class="col-md-6">

                  <b-form-group
                    class="mb-2"
                    id="donemler"
                    label=""
                    label-for="text"
                  >
                    <select
                      v-model="Filter.DonemId"
                      
                      class="form-select"
                      type="text"
                    >
                      <option value=""
                        >{{$t('StrGostergeGirisi.Filtreleme.UstId')}}</option
                      >
                      <option
                        v-for="DonemVerileri in ComboboxDonemler"
                        :key="DonemVerileri.Id"
                        :value="DonemVerileri.Id"
                      >
                        {{ DonemVerileri.Aciklama }}
                      </option></select
                    >
                  </b-form-group>
                  </div>
                  </div>
              
                  <div class="row">
                  <div class="col-md-6">

                      <BirimSecimi
                        :title="''"
                        :title_class="'mb-2'"
                        :closeOnSelect="true"
                        :sutun="'0'"
                        :multiple="false"
                        :YetkiKontrol="1"
                        :BirimTipId="null"
                        @Secilmis_Idler="Secilmis_Idler($event)"
                      />

                  </div>
                  </div>
                 <!--      {{secilen_birim}}  -->
          <!--        <div class="row">
                  <div class="col-md-6">
                  <b-form-group
                    class="mb-2"
                    id="gdonemler"
                    label=""
                    label-for="text"
                  >
                    <select
                      v-model="Filter.TabloId"
                      class="form-select"
                      type="text"
                    >
                      <option value="">{{this.$t('StrGostergeGirisi.Filtreleme.TabloId')}}</option>
                      <option
                        v-for="Tablolar in ComboboxTablolar"
                        :key="Tablolar.Id"
                        :value="Tablolar.Id"
                      >
                        {{ Tablolar.Adi }} 
                      </option></select >
                  </b-form-group>
                  </div>
                  </div>
                     {{Filter.TabloId}} -->
                <div class="row">
                  <div class="col-md-6">
                  <b-form-group
                    class="mb-2"
                    id="gdonemler"
                    label=""
                    label-for="text"
                  >
                    <div class="button-items">
                      <button
                  
                        style="width:99%; margin-bottom:20px"
                        type="button"
                        @click="yukle()"
                        class="btn btn-primary"
                      >
                        Yükle
                      </button>
                    </div>
                  </b-form-group>
                  </div>
                  </div> 
                </div>


              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ANCHOR Komponent alanı -->

     
    

      <div class="row">
    
        <div class="col-12">
          <div class="card">
            
            <div class="card-body">
             <!--    {{YuklenenTablolar}} -->

          
            

              <div v-for="(Tablolar,index) in YuklenenTablolar" :key="index">
              
                <GostergeGirisiTablo
                  :Onayid="index"
                  :TabloId="Tablolar.Id"
                  :BirimId="secilen_birim"
                  :DonemId="secilen_donem"
                  :Sorgulama="sorgula"
                  :Universite="universite"
                  @Raporgirisid="Raporgirisid = $event"
                  @OnayDurumu="OnayDurumu = $event"
                  @Kontrolgirisid="Kontrolgirisid = $event"
                  @DetayId="DetayId = $event"
                  @BirimId="BirimId = $event"
                  @DonemId="DonemId = $event"
                  @TabloDetayAciklama="TabloDetayAciklama = $event"
                  @TabloDetay="TabloDetay = $event"
                  @Hesaplanmasin="Hesaplanmasin = $event"
                  @AltDonemlerDetay="AltDonemlerDetay = $event"
                  @Guncelle="yukle()"
                  @yuklendi="loading=1"
                />

              </div>

            </div>
          </div>
        </div>
      </div>


    
        <KanitGiris v-if="Raporgirisid" :Raporgirisid="Raporgirisid" :Kontrolgirisid="Kontrolgirisid"
        :OnayDurumu="OnayDurumu"/>
  


      <b-modal id="modal-lg2" size="xl" title-class="font-18" hide-footer>

        <DetayGiris 
        :DetayId="DetayId" 
        :UstDonemId="UstDonemId"
        :DonemId="DonemId" 
        :BirimId="BirimId" 
        :Raporgirisid="Raporgirisid"
        :TabloDetayAciklama="TabloDetayAciklama" 
        :Hesaplanmasin="Hesaplanmasin"
        :AltDonemlerDetay="AltDonemlerDetay" 
        @TabloyuGuncelle= "yukle()"     
        />
        
      </b-modal>


      <b-modal v-if="TabloDetay" id="Aciklama" size="lg" title-class="font-18" hide-footer>
          <textarea   id="aciklama" 
            name="aciklama" 
          v-on:input="TabloDetay.Aciklama = $event.target.value"   
          v-bind:value="TabloDetay.Aciklama"    
          maxlength="4000" rows="12" placeholder="" 
          class="form-control"></textarea>
            <br>

      <button class="btn btn-primary" @click="kaydet(TabloDetay)" type="button">Kaydet</button>
      </b-modal>

      <b-modal v-if="TabloDetay" id="AciklamaOku" size="lg" title-class="font-18" hide-footer>
          <textarea   id="AciklamaOku" 
            name="aciklama" 
          v-on:input="TabloDetay.Aciklama = $event.target.value"   
          v-bind:value="TabloDetay.Aciklama"    
          maxlength="4000" rows="12" placeholder="" 
          class="form-control"></textarea>
            <br>

       

      <button class="btn btn-primary" @click="$bvModal.hide('AciklamaOku')" type="button">Kapat</button>
      </b-modal>

    </Layout>
    <yukleniyor v-if="loading==0"></yukleniyor>
  </Loader>
 
</template>
